/*
loading: false,
        responseBody: (action.type) ? action : action.payload.error,
        error: action.payload.message,
        errorObject:action.payload
        */

import Analytics from "./analytics";
import Assignment from "./assignment";

 
class Models{
            constructor(params){
                this.accountType = "accounts";
                this.tbl = {};
                this.accounts = {};
                this.Assignment;
                this._types = {
                    "analytics":Analytics,
                    "assignment":Assignment
                 }

                
                 
                for (var ks of Object.keys(params.accounts)){
                    if (this._types[ks.toLowerCase()]){
                        var model;
                        if (ks.toLowerCase() == "analytics"){
                    model = new this._types[ks.toLowerCase()](params);
                    this.setModelParameters(model)
                        }else{
                            for (var pt of params.permissionsTable){
                                this.tbl[pt.accountId+"-"+pt.pivotAccountId] = (this.tbl[pt.accountId+"-"+pt.pivotAccountId]) ? this.tbl[pt.accountId+"-"+pt.pivotAccountId] : [];
                                this.tbl[pt.accountId+"-"+pt.pivotAccountId].push(pt);
                             }
                             params.permissionsTable = this.tbl;
                             model = new this._types[ks.toLowerCase()](params);
                             this.accounts.Assignment = model;
                        }
                    
                    }
                }
                 
                 
                
        }

          
            
              
            
            setModelParameters(params){
                this[this.accountType] = params;
                
            }

            getTypes(){
                var ret = Object.keys(this._types).map((t) => {
                        var lbl = (t.charAt(0).toUpperCase()+t.slice(1));
                        return lbl;
                })
                return ret;
            }
           

        
        }
export default Models;
          

